import { supabase } from '../lib/supabase'

// Reader calls added for the richer Product Knowledge screens. Same contract as the
// existing productKnowledgeService: resolve with the data, throw on error.
// (Server side: catalog_get_screen_detail / catalog_get_workflow_detail / catalog_get_item /
// catalog_list_terms -- read-only, audience-filtered, signed-in readers only.)
async function call(fn, args) {
  const { data, error } = await supabase.rpc(fn, args)
  if (error) throw error
  return data
}

export const getScreenDetail = (key) => call('catalog_get_screen_detail', { p_key: key })
export const getWorkflowDetail = (key) => call('catalog_get_workflow_detail', { p_key: key })
export const getItem = (key, kind) => call('catalog_get_item', { p_key: key, p_kind: kind })
export const listTerms = () => call('catalog_list_terms')
